// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__TTYAt","mobileSidebar":"Sidebar_mobileSidebar__LdK-5","link":"Sidebar_link__mVAGN","linkSelected":"Sidebar_linkSelected__xXTJ7"};